/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React, { Fragment, useContext } from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { transformFormValue } from '../form/transformFormData';
import { FormContext } from '../form';
var isEqual = function isEqual(first, second) {
  if (first === second) {
    return true;
  }
  if (Array.isArray(first) && Array.isArray(second)) {
    return first.sort().toString() === second.sort().toString();
  }
  return false;
};
var FormCondition = function FormCondition(_ref) {
  var when = _ref.when,
    is = _ref.is,
    _ref$areChildrenPersi = _ref.areChildrenPersisted,
    areChildrenPersisted = _ref$areChildrenPersi === void 0 ? false : _ref$areChildrenPersi,
    children = _ref.children;
  var formContext = useContext(FormContext);
  var shouldShowChildren = isEqual(transformFormValue(formContext === null || formContext === void 0 ? void 0 : formContext.formValues[when]), is);
  if (areChildrenPersisted) {
    return jsx("div", {
      // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
      css: css({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        display: shouldShowChildren ? 'block' : 'none'
      })
    }, children);
  } else {
    return jsx(Fragment, null, shouldShowChildren ? children : null);
  }
};
export default FormCondition;
export var FormConditionFn = function FormConditionFn(_ref2) {
  var props = _ref2.props,
    children = _ref2.children,
    Components = _ref2.Components,
    dispatch = _ref2.dispatch,
    render = _ref2.render,
    renderChildren = _ref2.renderChildren;
  var _ref3 = props,
    when = _ref3.when,
    is = _ref3.is,
    areChildrenPersisted = _ref3.areChildrenPersisted;
  return jsx(FormCondition, {
    when: when,
    is: is,
    areChildrenPersisted: areChildrenPersisted
  }, renderChildren({
    children: children,
    render: render,
    dispatch: dispatch,
    Components: Components
  }));
};